import '../Styles/ProjectionsStyles.css';
import { Component } from 'preact';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import LateralProjectionComponent from './LateralProjectionComponent.js';
import FrenteProjectionComponent from './FrenteProjectionComponent.js';
import BaseProjectionComponent from './BaseProjectionComponent.js';

class ProjectionsComponent extends Component {

  constructor(props){
    super(props)
    this.state = {
    }
  }

  render(){
    return (
      <div class="row" style={{marginTop:"30px"}}>
      <div class=" col-sm-3">
      <LateralProjectionComponent  complete_data={this.props.complete_data} detrital_data={this.props.detrital_data} filteredData_detrital={this.props.filteredData_detrital} filteredData_panel={this.props.filteredData_panel} filteredData_umap={this.props.filteredData_umap} filteredData_projection={this.props.filteredData_projection}  cbk_filteredData_projection={this.props.cbk_filteredData_projection} cbk_filteredData_umap={this.props.cbk_filteredData_umap} clkSeleccDetrital={this.props.clkSeleccDetrital} cbk_filtered_Data_detrital={this.props.cbk_filtered_Data_detrital}/>
      </div>
      <div class=" col-sm-1">
      </div>
      <div class=" col-sm-3">
      <FrenteProjectionComponent complete_data={this.props.complete_data} detrital_data={this.props.detrital_data} filteredData_detrital={this.props.filteredData_detrital} filteredData_panel={this.props.filteredData_panel} filteredData_umap={this.props.filteredData_umap} filteredData_projection={this.props.filteredData_projection} cbk_filteredData_projection={this.props.cbk_filteredData_projection} cbk_filteredData_umap={this.props.cbk_filteredData_umap} clkSeleccDetrital={this.props.clkSeleccDetrital} cbk_filtered_Data_detrital={this.props.cbk_filtered_Data_detrital}/>
      </div>
      <div class=" col-sm-1">
      </div>
      <div class=" col-sm-3" style={{left:"5rem"}}>
      <BaseProjectionComponent complete_data={this.props.complete_data} detrital_data={this.props.detrital_data} filteredData_detrital={this.props.filteredData_detrital} filteredData_panel={this.props.filteredData_panel} filteredData_umap={this.props.filteredData_umap} filteredData_projection={this.props.filteredData_projection} cbk_filteredData_projection={this.props.cbk_filteredData_projection} cbk_filteredData_umap={this.props.cbk_filteredData_umap} clkSeleccDetrital={this.props.clkSeleccDetrital} cbk_filtered_Data_detrital={this.props.cbk_filtered_Data_detrital}/>
      </div>
      <div class=" col-sm-1">
      </div>
      </div>
    );
  }

}
export default ProjectionsComponent;
